/* eslint-disable @stylistic/max-len */

import {
  Result,
  RESULT_VARIANT_SUCCESS,
} from '@sgcmpteltd/uikit-react/components/result';
import cx from 'clsx';
import { useContext, useState } from 'react';

import { sendMagicLinkAction } from '@/actions/member/send-magic-link';
import { UserContext } from '@/context/user';
import { maskEmail } from '@/utils/string/maskEmail';

import { UnlockRewardsSection } from '../unlock-rewards-section/components';
import styles from './styles.module.scss';
import type { Component } from './types';

export const SuccessStep: Component = ({
  className,
  userEmail,
  userMobile,
  successMessage,
  regSource,
}) => {
  const user = useContext(UserContext);
  const [isQuickSignUp, setIsQuickSignUp] = useState(false);
  const [isLinkResent, setIsLinkResent] = useState(false);

  const handleQuickSignUp = async () => {
    setIsLinkResent(false);

    if (!userEmail || !userMobile) return;

    setIsQuickSignUp(true);

    try {
      const formData = new FormData();

      formData.append('email', userEmail);
      formData.append('mobileNumber', userMobile);

      if (regSource) {
        formData.append('regSource', regSource);
      }

      await sendMagicLinkAction(formData);
      setIsLinkResent(true);
    } catch (error) {
      console.error(error);
    } finally {
      setIsQuickSignUp(false);
    }
  };

  const isLoggedIn = !!user?.username && !!user?.userId;

  return (
    <div
      className={cx(
        styles.containerRoot,
        className,
      )}>
      <div className={styles.containerResult}>
        <Result
          message={(
            <div className={styles.textMessage}>
              <div className={styles.successTitle}>Successfully Submitted!</div>
              <div className={styles.successMessage}>
                {successMessage}
              </div>
              <UnlockRewardsSection
                isFetchingQuickSignUp={isQuickSignUp}
                isLinkResent={isLinkResent}
                isLoggedIn={isLoggedIn}
                quickSignUp={handleQuickSignUp}
                userEmail={userEmail ? maskEmail(userEmail) : ''} />
            </div>
          )}
          title=""
          variant={RESULT_VARIANT_SUCCESS} />
      </div>
    </div>
  );
};
